import styled from 'styled-components';
import SimpleBar from 'simplebar-react';
import { ButtonV2 } from '@getgrover/ui';
import { screens } from 'ggApp/utils/mixins/screens';
import CleanArrowNext from './icons/CleanArrowNext';
import CleanArrowPrevious from './icons/CleanArrowPrevious';

export const TopControlButtonsWrapper = styled.section`
    position: absolute;
    right: ${({ theme }) => theme.spacers.L};
    display: inline-flex;

    @media (${screens.desktop}) {
        right: 5%;
    }
`;

export const ControlButton = styled(ButtonV2)`
    margin-left: ${({ theme }) => theme.spacers.M};
`;

export const NextArrowIcon = styled(CleanArrowNext)`
    margin-left: ${({ theme }) => theme.spacers.S};
`;

export const PrevArrowIcon = styled(CleanArrowPrevious)`
    margin-right: ${({ theme }) => theme.spacers.S};
`;

export const Slider = styled(SimpleBar)`
    display: flex;
    width: 100%;

    @media (${screens.phone}) and (${screens.tabletMax}) {
        padding-bottom: ${({ theme }) => theme.spacers.XL};
    }

    @media (${screens.tablet}) {
        padding-bottom: ${({ theme }) => theme.spacers.XXL};
    }

    .simplebar-horizontal {
        height: 2px;
        background-color: ${({ theme }) => theme.colors['Level 1']};
        border-radius: 2px;
    }

    .simplebar-track.simplebar-horizontal {
        @media (${screens.phone}) and (${screens.tabletMax}) {
            margin-left: ${({ theme }) => theme.spacers.L};
            margin-right: ${({ theme }) => theme.spacers.L};
        }
    }

    .simplebar-track.simplebar-horizontal .simplebar-scrollbar {
        height: 2px;
        top: 0;
    }

    .simplebar-scrollbar {
        height: 100%;
        background-color: ${({ theme }) => theme.colors.Foreground};
        border-radius: 2px;
    }

    .simplebar-content {
        display: flex;
    }
`;
